import { useQuery } from '@do/graphql-client';
import { Session, Session_sessionData } from '../generated-types/Session';
import { GET_SESSION } from '../queries/queries';
import { PUBLIC_ENDPOINT } from '../constants';

const useSession = (): Session_sessionData => {
  const { data: { sessionData } = {} } = useQuery<Session>(GET_SESSION, {
    context: {
      url: PUBLIC_ENDPOINT,
    },
  });

  return {
    session_id: sessionData?.session_id || null,
  };
};

export default useSession;
